import { c as _c } from "react/compiler-runtime";
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/utils';
import { ComponentProps, ReactNode } from 'react';
type Option = string | {
  value: string;
  label: ReactNode;
  disabled?: boolean;
};
type ViverseRadioProps = Omit<ComponentProps<typeof RadioGroup>, 'onValueChange' | 'value'> & {
  options: Option[];
  onValueChange: (value: string) => void;
  value?: string;
  wrapperClassName?: string;
  optionRowClassName?: string;
  radioItemClassName?: string;
  labelClassName?: string;
};
export default function ViverseRadio(t0) {
  const $ = _c(32);
  let className;
  let labelClassName;
  let onValueChange;
  let optionRowClassName;
  let options;
  let props;
  let radioItemClassName;
  let value;
  let wrapperClassName;
  if ($[0] !== t0) {
    ({
      options,
      onValueChange,
      value,
      wrapperClassName,
      optionRowClassName,
      radioItemClassName,
      labelClassName,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = labelClassName;
    $[3] = onValueChange;
    $[4] = optionRowClassName;
    $[5] = options;
    $[6] = props;
    $[7] = radioItemClassName;
    $[8] = value;
    $[9] = wrapperClassName;
  } else {
    className = $[1];
    labelClassName = $[2];
    onValueChange = $[3];
    optionRowClassName = $[4];
    options = $[5];
    props = $[6];
    radioItemClassName = $[7];
    value = $[8];
    wrapperClassName = $[9];
  }
  let t1;
  if ($[10] !== wrapperClassName) {
    t1 = cn("flex w-fit items-center gap-[16px]", wrapperClassName);
    $[10] = wrapperClassName;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== className) {
    t2 = cn("flex flex-col", className);
    $[12] = className;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== labelClassName || $[15] !== optionRowClassName || $[16] !== options || $[17] !== radioItemClassName) {
    let t4;
    if ($[19] !== labelClassName || $[20] !== optionRowClassName || $[21] !== radioItemClassName) {
      t4 = (option, index) => {
        const normalized = typeof option === "string" ? {
          value: option,
          label: option
        } : option;
        const id = `radio-option-${index}-${normalized.value}`;
        return <div key={id} className={cn("flex items-center py-[10px]", optionRowClassName)}><RadioGroupItem id={id} value={normalized.value} disabled={normalized.disabled} className={cn("border-vive-primary-70 bg-vive-primary-70 size-[20px] border-[1.5px]", "hover:bg-vive-primary-60 data-[state=checked]:border-primary", "*:fill-current *:text-current data-[state=checked]:border-[1.5px]", radioItemClassName)} /><Label htmlFor={id} className={cn("body-1 cursor-pointer pl-3 peer-disabled:cursor-not-allowed peer-disabled:opacity-70", labelClassName)}>{normalized.label}</Label></div>;
      };
      $[19] = labelClassName;
      $[20] = optionRowClassName;
      $[21] = radioItemClassName;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    t3 = options.map(t4);
    $[14] = labelClassName;
    $[15] = optionRowClassName;
    $[16] = options;
    $[17] = radioItemClassName;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[23] !== onValueChange || $[24] !== props || $[25] !== t2 || $[26] !== t3 || $[27] !== value) {
    t4 = <RadioGroup value={value} onValueChange={onValueChange} className={t2} {...props}>{t3}</RadioGroup>;
    $[23] = onValueChange;
    $[24] = props;
    $[25] = t2;
    $[26] = t3;
    $[27] = value;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  let t5;
  if ($[29] !== t1 || $[30] !== t4) {
    t5 = <div className={t1}>{t4}</div>;
    $[29] = t1;
    $[30] = t4;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  return t5;
}